import * as React from "react";
import { forwardRef } from "react";
const SvgSmartphone = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-smartphone-icon lucide-smartphone", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 14, height: 20, x: 5, y: 2, rx: 2, ry: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M12 18h.01" }));
const ForwardRef = forwardRef(SvgSmartphone);
export default ForwardRef;
